import { render, staticRenderFns } from "./PlayerNotFetched.vue?vue&type=template&id=489f6f71&"
import script from "./PlayerNotFetched.vue?vue&type=script&lang=js&"
export * from "./PlayerNotFetched.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports